import { Component } from 'react';
import AppVo from '../blogData/AppVo';
interface MyProps { appVo: AppVo, color: string, callback: Function }
interface MyState { }
class AppCard2 extends Component<MyProps, MyState>
{

    constructor(props: MyProps) {
        super(props);
        this.state = {};
    }
    render() {
        let icon: string = this.props.appVo.icon;
        if (icon === "") {
            icon = "fas fa-pencil-alt";
        }

        let description: string = this.props.appVo.description;
        if (description === "") {
            description = "No description available";
        }
        return (
            <div className="appcards__cards-inner" style={{ "backgroundColor": this.props.color }} onClick={() => { this.props.callback(this.props.appVo) }}>
                <div className='appcards__cardicon'>
                    <i className={icon}></i>
                </div>
                <div>
                    <div className='appcards__title'>{this.props.appVo.title}</div>
                    <p className='appcards__description'>
                        {description}
                    </p>
                </div>
            </div>
        )
    }
}
export default AppCard2;